import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "demo",
  "use": "demo-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" id=\"demo\">\n<path d=\"M12.5795 6.99997H19.8966L21.36 12H11.36L12.5795 6.99997Z\" />\n<path d=\"M8.3356 14H14.1893L15.36 19H7.35999L8.3356 14Z\" />\n<path d=\"M18.3356 14H24.1893L25.36 19H17.36L18.3356 14Z\" />\n<path d=\"M3.45755 21H10.0429L11.36 27H2.35999L3.45755 21Z\" />\n<path d=\"M12.5795 21H19.8966L21.36 27H11.36L12.5795 21Z\" />\n<path d=\"M22.4575 21H29.0429L30.36 27H21.36L22.4575 21Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol